import Swiper from 'swiper';
import {Pagination, Keyboard, A11y} from 'swiper/modules';

new Swiper('.swiper-product-images', {
// configure Swiper to use modules
  modules: [Pagination, Keyboard, A11y],
  slidesPerView: 1,
  keyboard: {
    enabled: true,
  },

  pagination: {
    enabled: true,
    el: '.swiper-pagination',
    clickable: true,
  },
});

